import fetch ,{postFrom,getBlob2} from "../utils/fetch";

export function downloadInvoiceList() {
  return getBlob2({
    method: 'GET',
    url: 'invoice/downloadInvoiceList',
  })


}

export function projectByCooperationMode(params) {
  return fetch({
    method: 'GET',
    url: '/projectBasics/projectByCooperationMode',
    params
  })
}

export function invoicelist(params) {
  return fetch({
    method: 'POST',
    url: '/invoice/list',
    data:params
  })
}

export function invoicelistcondition() {
  return fetch({
    method: 'GET',
    url: '/invoice/list/condition',
  })
}

export function invoiceCompetencylist(params) {
  return fetch({
    method: 'GET',
    url: '/invoice/invoiceCompetency/list',
    params
  })
}
export function saveInvoiceCompetency(params) {
  return fetch({
    method: 'POST',
    url: '/invoice/saveInvoiceCompetency',
    data:params
  })
}

export function updateInvoiceCompetency(params) {
  return fetch({
    method: 'POST',
    url: '/invoice/updateInvoiceCompetency',
    data:params
  })
}

export function getInvoiceCompetency(params) {
  return fetch({
    method: 'GET',
    url: '/invoice/getInvoiceCompetency',
    params
  })
}
export function getApplyInvoiceBaseInfo(params) {
  return fetch({
    method: 'GET',
    url: '/invoice/getApplyInvoiceBaseInfo',
    params
  })
}
export function verifyCompetencyByTaxNum(params) {
  return fetch({
    method: 'GET',
    url: '/invoice/verifyCompetencyByTaxNum',
    params
  })
}
// export function getInvoiceAmountAndCycleByMonth(params) {
//   return fetch({
//     method: 'GET',
//     url: '/invoice/getInvoiceAmountAndCycleByMonth',
//     params
//   })
// }
export function getInvoiceAmountAndCycleByMonth(params) {
  return fetch({
    method: 'POST',
    url: '/invoice/getInvoiceAmountAndCycleByMonth',
    data:params
  })
}
export function getInvoiceAmountAndMonth(params) {
  return fetch({
    method: 'GET',
    url: '/invoice/getInvoiceAmountAndMonth',
    params
  })
}

export function saveInvoiceInfo(params) {
  return fetch({
    method: 'POST',
    url: '/invoice/saveInvoiceInfo',
    data:params
  })
}
export function getInvoiceInfoByFid(params) {
  return fetch({
    method: 'GET',
    url: '/invoice/getInvoiceInfoByFid',
    params
  })
}

export function applycancel(params) {
  return fetch({
    method: 'POST',
    url: '/invoice/apply/cancel',
    params
  })
}
export function modifyInvoiceStatus(params) {
  return fetch({
    method: 'GET',
    url: '/invoice/modifyInvoiceStatus',
    params
  })
}
export function getCompanyRegdAddress() {
  return fetch({
    method: 'GET',
    url: '/invoice/getCompanyRegdAddress'
  })
}



